import React from 'react'
import { makeStyles } from '@material-ui/core'
import AlarmIcon from '@material-ui/icons/Alarm'
import { EmailIcon, NotificationIcon, SmsIcon } from '../icons'

const useStyles = makeStyles(() => ({
  commsTypesContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
}))

export const CommunicationTypes = ({ isDateSequence, communications }) => {
  const { commsTypesContainer } = useStyles()
  const commsTypes = communications.reduce(
    (acc, comm) => {
      if (comm.actionType.name === 'EMAIL' && !acc.hasEmail) {
        acc.hasEmail = true
      }
      if (comm.actionType.name === 'NOTIFICATION' && !acc.hasNotification) {
        acc.hasNotification = true
      }
      if (comm.actionType.name === 'SMS' && !acc.hasSms) {
        acc.hasSms = true
      }
      return acc
    },
    { hasEmail: false, hasNotification: false, hasSms: false },
  )
  return (
    <div className={commsTypesContainer}>
      {isDateSequence && <AlarmIcon />}
      {commsTypes.hasEmail && <EmailIcon />}
      {commsTypes.hasNotification && <NotificationIcon />}
      {commsTypes.hasSms && <SmsIcon />}
    </div>
  )
}
